import isEqual from 'lodash/isEqual';
import type { Filter, Owner, Query } from './index.tsx';

const getOwnerIdentifier = (owner: Owner) => owner.accountId;

const getQueryValues = (target: Query) => {
	const { page, sortField, sortDirection, filter } = target;
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const { query, owner, project, group } = filter as Filter;
	return {
		page,
		sortField,
		sortDirection,
		filter: {
			query,
			owner: owner && getOwnerIdentifier(owner),
			project: project && project.value,
			group: group && group.value,
		},
	};
};

export const isQueryChanged = (newQuery: Query, prevQuery: Query): boolean =>
	!isEqual(getQueryValues(newQuery), getQueryValues(prevQuery));
